module.exports = __webpack_public_path__ + "static/media/cam.164ed875.svg";